// extracted by mini-css-extract-plugin
module.exports = {"tv_form__btns":"TokenVesting_tv_form__btns__az1wv"};